<dialog-header
  [title]="automation ? 'Edit Automation' : 'Create Automation'"
  (onClose)="close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
    padding: 20px;
  "
>
  <form [formGroup]="form">
    <!-- Name -->
    <div class="form-field" style="margin-top: 20px">
      <div class="form-field-label">
        Automation Name<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        placeholder="e.g. Reward customer when they take a loyalty card"
        [formControl]="nameFormControl"
        type="text"
      />
    </div>

    <!-- Trigger Section -->
    <div class="section-header">Trigger</div>

    <div class="form-field" style="margin-top: 20px">
      <div class="form-field-label">When this automation runs</div>
      <div class="form-input" style="display: flex; align-items: center">
        Customer takes loyalty card
      </div>
    </div>

    <div class="filter-section">
      <div class="form-field" style="margin-bottom: 0">
        <multiple-select
          label="Applies when the customer takes one of these loyalty cards"
          [formCtrl]="conditionCardsFormControl"
          [options]="cards"
          [showAll]="false"
          value="title"
        >
        </multiple-select>
      </div>
    </div>

    <!-- Action Section -->
    <div class="section-header">Action</div>

    <div class="form-field" style="margin-top: 20px">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="form-field-label" style="margin-bottom: 0px">
          Send Push Notification
        </div>
        <mat-slide-toggle
          [checked]="sendPushNotification"
          (change)="togglePushNotification()"
        ></mat-slide-toggle>
      </div>

      <div *ngIf="sendPushNotification" style="margin-top: 10px">
        <div class="form-field-label">
          Message<span style="color: red">*</span>
        </div>
        <textarea
          class="form-input"
          autocomplete="off"
          placeholder="Enter your message..."
          [formControl]="messageFormControl"
          rows="3"
          [maxlength]="contentMaxChar"
          (click)="updateCursorPosition($event)"
          (keyup)="updateCursorPosition($event)"
          (select)="updateCursorPosition($event)"
        ></textarea>
        <div style="text-align: right; font-size: 12px; color: gray">
          {{ messageFormControl.value?.length || 0 }}/{{ contentMaxChar }}
        </div>

        <div
          style="display: flex; justify-content: flex-start; margin-top: 10px"
        >
          <div
            class="emoji-button"
            style="margin-right: 10px"
            (click)="openEmojiPicker()"
          >
            😊 Emoji
          </div>
          <div class="emoji-button" (click)="insertCustomerNameAtCursor()">
            + Customer Name
          </div>
        </div>
      </div>
    </div>

    <div class="form-field" style="margin-top: 20px">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="form-field-label" style="margin-bottom: 0px">
          Include Reward(s)
        </div>
        <mat-slide-toggle
          [checked]="includeReward"
          (change)="toggleReward()"
        ></mat-slide-toggle>
      </div>

      <div *ngIf="includeReward" style="margin-top: 10px">
        <div
          class="social-container"
          *ngFor="let item of rewards"
          style="
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>
            <div
              style="
                margin-bottom: 0px !important;
                color: black;
                font-size: 16px;
              "
            >
              {{ item?.reward?.title }}
            </div>
          </div>

          <mat-icon
            style="color: red; cursor: pointer"
            (click)="removeReward(item)"
            >cancel
          </mat-icon>
        </div>

        <div style="margin-top: 10px">
          <choose-reward
            (clicked)="openRewardDialog()"
            [label]="rewards.length ? 'Add Another Reward' : 'Choose Reward'"
            [icon]="'redeem'"
          ></choose-reward>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isScheduleTrigger">
      <!-- Target Section -->
      <div class="section-header">Target</div>

      <div class="form-field" style="margin-top: 20px">
        <single-select
          label="Send to"
          [formCtrl]="targetTypeFormControl"
          [options]="targetTypes"
          property="label"
        ></single-select>
      </div>

      <div *ngIf="isFiltered" class="filter-section">
      <!-- Filter toggles -->
      <div *ngFor="let filter of filterOptions">
        <div style="margin-top: 20px; margin-bottom: 20px">
          <div style="display: flex; justify-content: space-between">
            <div
              class="form-field-label"
              style="color: black; font-weight: normal; margin-bottom: 0px"
            >
              {{ filter?.label }}
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="filters[filter.key]"
              (change)="toggleFilter(filter.key, $event.checked)"
            >
            </mat-slide-toggle>
          </div>
          <div
            style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
              text-align: right;
            "
            *ngIf="filter.followOn && filters[filter.key]"
          >
            <div
              class="form-field-label"
              style="
                color: black;
                font-weight: normal;
                flex: 3;
                margin-bottom: 0px;
                margin-right: 10px;
              "
            >
              {{ filter?.followOn?.label }}
            </div>
            <input
              style="flex: 1"
              class="form-input"
              autocomplete="off"
              placeholder="e.g. 14"
              (input)="
                toggleFilter(
                  filter.followOn.key,
                  filter.followOn.formControl.value
                )
              "
              [formControl]="filter.followOn.formControl"
              type="number"
              [maxlength]="4"
              min="0"
              oninput="
                javascript: if (this.value.length > this.maxLength)
                  this.value = this.value.slice(0, this.maxLength);
              "
            />
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              align-items: flex-end;
            "
            *ngIf="
              filter.key === 'specificRewardNotReceived' && filters[filter.key]
            "
          >
            <div style="width: 95%; margin-bottom: 10px">
              <single-select
                label="Select reward"
                [formCtrl]="specificRewardFormControl"
                [options]="availableRewards"
                property="title"
                [showSearch]="true"
                (selected)="
                  toggleFilter('specificRewardNotReceivedReward', $event?._id)
                "
              >
              </single-select>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              align-items: flex-end;
            "
            *ngIf="filter.key === 'hasVoucher' && filters[filter.key]"
          >
            <div style="width: 95%; margin-bottom: 10px">
              <multiple-select
                label="Select vouchers"
                [formCtrl]="selectedVouchersFormControl"
                [options]="vouchers"
                [showAll]="false"
                value="displayTitle"
              >
              </multiple-select>
            </div>
            <div style="width: 95%">
              <multiple-select
                label="Voucher status"
                [formCtrl]="selectedVoucherStatusFormControl"
                [options]="voucherStatusOptions"
                [showAll]="false"
                value="label"
                subtitle="description"
              >
              </multiple-select>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(cards ?? []).length > 1">
        <hr />
        <div style="margin-top: 20px; margin-bottom: 20px">
          <div style="display: flex; justify-content: space-between">
            <div
              class="form-field-label"
              style="color: black; font-weight: normal; margin-bottom: 0px"
            >
              Filter by loyalty card
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="filters['hasCard']"
              (change)="toggleFilter('hasCard', $event.checked)"
            >
            </mat-slide-toggle>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              align-items: flex-end;
            "
            *ngIf="filters['hasCard']"
          >
            <div style="width: 95%">
              <multiple-select
                label="Send to customers who have the following cards:"
                [formCtrl]="selectedCardsFormControl"
                [options]="cards"
                [showAll]="false"
                value="title"
              >
              </multiple-select>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Frequency Section -->
      <div class="section-header">Frequency</div>

      <div class="form-field" style="margin-top: 20px">
        <single-select
          label="How often"
          [formCtrl]="frequencyTypeFormControl"
          [options]="frequencyTypes"
          property="label"
        ></single-select>
      </div>

      <div class="form-field" style="margin-top: 20px">
        <single-select
          label="Time"
          [formCtrl]="timeFormControl"
          [options]="times"
        ></single-select>
      </div>

      <div *ngIf="showDatePicker" class="form-field" style="margin-top: 20px">
        <div class="form-field-label">Date</div>
        <input
          class="form-input"
          autocomplete="off"
          type="date"
          [formControl]="dateFormControl"
        />
      </div>

      <div *ngIf="showDayOfWeek" class="form-field" style="margin-top: 20px">
        <single-select
          label="Day of Week"
          [formCtrl]="dayOfWeekFormControl"
          [options]="daysOfWeek"
          property="label"
        ></single-select>
      </div>

      <div *ngIf="showDayOfMonth" class="form-field" style="margin-top: 20px">
        <div class="form-field-label">Day of Month</div>
        <input
          class="form-input"
          autocomplete="off"
          type="number"
          min="1"
          max="31"
          placeholder="1-31"
          [formControl]="dayOfMonthFormControl"
        />
      </div>

      <div
        *ngIf="showMilestoneFields"
        class="form-field"
        style="margin-top: 20px"
      >
        <single-select
          label="Select Card"
          [formCtrl]="milestoneCardFormControl"
          [options]="cards"
          property="title"
        ></single-select>
      </div>

      <div
        *ngIf="showMilestoneFields"
        class="form-field"
        style="margin-top: 20px"
      >
        <div class="form-field-label">
          Number of Stamps<span style="color: red">*</span>
        </div>
        <input
          class="form-input"
          type="number"
          min="1"
          [formControl]="milestoneThresholdFormControl"
          placeholder="e.g. 5"
        />
      </div>
    </ng-container>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    title="Cancel"
    [disabled]="saving"
    (tapped)="close()"
    style="margin-right: 10px"
  ></app-secondary-button>
  <app-primary-button
    [title]="automation ? 'Update' : 'Create'"
    [disabled]="saving || !form.valid"
    (tapped)="save()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="saving || loadingData"></loader>
